import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: 'nav.component.html'
})
export class NavComponent {
  constructor(
  ) { }

  @Input() links = <any>[];
}
